<template>
  <section class="section">
    <b-field>
      <b-input
        v-model="newInvitationCodeData.code"
        type="text"
        :placeholder="$t('codigo')"
      ></b-input>
      <p class="control">
        <button @click="callPostNewInvitationCode" class="button is-success">
          {{ $t('Crear') }}
        </button>
      </p>
    </b-field>
    <b-table
      :loading="isLoading"
      :paginated="true"
      :per-page="10"
      :striped="true"
      :hoverable="true"
      default-sort="created_at"
      :data="codes"
    >
      <template slot-scope="props">
        <b-table-column :label="$t('Tipo')">{{
          props.row.type | formatInvitationCodeType
        }}</b-table-column>
        <b-table-column :label="$t('Código')">{{
          props.row.code
        }}</b-table-column>
        <b-table-column :sortable="true" field="createdAt"  :label="$t('Creado')">{{
          props.row.createdAt | formatTimestamp
        }}</b-table-column>
        <b-table-column label=" ">
          <button
            @click="callDeleteInvitationCode(props.row.code)"
            class="button is-small is-danger"
            type="button"
          >
            <b-icon icon="trash-can" custom-size="default" />
          </button>
        </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>{{ $t('Cargando') }}...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>{{ $t('No hay resultados') }}&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

export default {
  name: 'InvitationCodes',
  mixins: [Fetcher],
  components: {},
  data() {
    return {
      codes: [],
      newInvitationCodeData: {
        code: null,
        type: 'C'
      }
    }
  },
  filters: {
    formatInvitationCodeType: function(value) {
      if (!value) return ''
      const typesMap = {
        P: 'Partner',
        C: 'Cliente'
      }
      return typesMap[value]
    }
  },
  methods: {
    ...mapActions('invitationCode', [
      'postNewInvitationCode',
      'getInvitationCodes',
      'deleteInvitationCode',
      'getInvitationCodeDetails'
    ]),
    async callGetInvitationCodes() {
      let self = this
      self.request(() =>
        self.getInvitationCodes().then(function(response) {
          self.codes = response.data.map(function(el) {
            return {
              type: el.SK.split('-')[0],
              code: el.SK,
              createdAt: el.created_at
            }
          })
        })
      )
    },
    callDeleteInvitationCode(id) {
      let self = this
      self.$dialog.confirm({
        message: self.$t('¿Estás seguro? esta operación no se puede deshacer'),
        type: 'is-danger',
        onConfirm: function() {
          self.request(() =>
            self.deleteInvitationCode(id).then(function() {
              self.callGetInvitationCodes()
            })
          )
        }
      })
    },
    callPostNewInvitationCode() {
      let self = this
      self.request(() =>
        self
          .postNewInvitationCode({
            code: `${self.newInvitationCodeData.type}-${self.newInvitationCodeData.code}`
          })
          .then(() => self.callGetInvitationCodes())
      )
    }
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Invitaciones'],
      title: 'Invitaciones'
    })
    this.callGetInvitationCodes()
  }
}
</script>

<style scoped></style>
